import React, { useEffect, useState } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import { CheckCircle2 } from 'lucide-react';
import { settleCheckoutSession, getSubscription } from '../lib/billing';

const PLAN_LABEL = { starter: 'Starter', business: 'Business', accountant: 'Accountant' };

export default function CheckoutSuccess() {
  const [params] = useSearchParams();
  const sid = params.get('session_id');
  const [sub, setSub] = useState(null);
  const [err, setErr] = useState('');

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        // Give the webhook a shot first.
        let s = await getSubscription();
        // If we don't yet have a subscription locally, settle via session.
        if ((!s || !s.plan_code) && sid) {
          await settleCheckoutSession(sid).catch(() => null);
          s = await getSubscription();
        }
        if (!cancelled) setSub(s || null);
      } catch (e) {
        if (!cancelled) setErr(e?.detail || 'Could not load your subscription');
      }
    })();
    return () => { cancelled = true; };
  }, [sid]);

  const trialEnd = sub?.trial_ends_at ? new Date(sub.trial_ends_at).toLocaleDateString() : null;
  const planName = PLAN_LABEL[sub?.plan_code] || sub?.plan_code || 'your new';

  return (
    <div
      data-testid="checkout-success"
      style={{
        minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center',
        padding: 24, background: '#F9FAFB', fontFamily: 'Inter, sans-serif',
      }}
    >
      <div style={{ maxWidth: 460, textAlign: 'center' }}>
        <div style={{ width: 72, height: 72, borderRadius: '50%', background: '#DCFCE7', color: '#0FC862', display: 'inline-flex', alignItems: 'center', justifyContent: 'center', marginBottom: 20 }}>
          <CheckCircle2 size={34} />
        </div>
        <h1 style={{ fontSize: 28, fontWeight: 800, letterSpacing: '-0.02em', color: '#0A0A0A', margin: 0 }}>
          You're all set.
        </h1>
        <p style={{ color: '#525966', marginTop: 10, fontSize: 15, lineHeight: 1.55 }}>
          {sub?.plan_code
            ? <>You're on the <strong style={{ color: '#0A0A0A' }}>{planName}</strong> plan.{trialEnd && sub.is_trialing ? <> Free trial active until <strong style={{ color: '#0A0A0A' }}>{trialEnd}</strong>.</> : null}</>
            : <>Thanks for subscribing. Your account will update momentarily.</>}
        </p>
        {err && <div style={{ marginTop: 10, color: '#DC2626', fontSize: 13 }}>{err}</div>}
        <Link
          to="/app"
          data-testid="success-cta"
          style={{
            display: 'inline-block', marginTop: 24, padding: '13px 24px', borderRadius: 10,
            background: '#0FC862', color: 'white', fontWeight: 700, textDecoration: 'none', fontSize: 15,
            boxShadow: '0 14px 36px -14px rgba(15, 200, 98, 0.4)',
          }}
        >
          Go to Clasifi
        </Link>
      </div>
    </div>
  );
}
